import React from 'react'
import Viewcustomer from '../../components/customer/viewcustomer'

export default function Customer() {
  return (
    <div className='px-4'>
        {/* List of existing customer */}
        <Viewcustomer/>
    </div>
  )
}

